import React from 'react';
import { LANGUAGES_OPTIONS } from '../register/options';

export const RegisterInternationalServices = ({ formData, handleChange, renderTagSelector }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4">International Patient Services</h3>
      
      {renderTagSelector('languages_spoken', LANGUAGES_OPTIONS, 'Languages Spoken')}
      
      <div className="mt-4">
        <label className="block text-sm font-medium mb-3">Services for International Patients</label>
        <div className="grid grid-cols-2 gap-3">
          {[
            { name: 'visa_assistance', label: 'Visa Assistance' },
            { name: 'airport_pickup', label: 'Airport Pickup' },
            { name: 'interpreter_services', label: 'Interpreter Services' }
          ].map(({ name, label }) => (
            <label key={name} className="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-gray-50">
              <input
                type="checkbox"
               
                checked={formData[name]}
                onChange={handleChange}
                className="w-4 h-4 rounded border-gray-300 text-[hsl(var(--primary))] focus:ring-[hsl(var(--primary))]"
              />
              <span className="text-sm">{label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <label className="block text-sm font-medium mb-1.5">About Your Hospital</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows="4"
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="Tell us about your hospital's history, achievements, specializations, and what makes it unique for international patients..."
        />
      </div>
    </div>
);
